import React from 'react';
import parse from 'html-react-parser';

const SwipeComponent = (props) => {
  const { currentItem, toNextItem, toPreviousItem, closeModal } = props;
  const currentModalDetails = {
    heading: currentItem.dataset.heading,
    text: currentItem.dataset.text,
    imageurl: currentItem.dataset.imageurl,
    videourl: currentItem.dataset.videourl,
  };

  let touchStartX = 0;
  let touchStartY = 0;
  let touchEndX = 0;
  let touchEndY = 0;

  const swipeThreshold = 100;

  const handleTouchStart = (e) => {
    touchStartX = e.touches[0].clientX;
    touchStartY = e.touches[0].clientY;
  };

  // const handleTouchMove = (e) => {
  //   e.preventDefault();
  // };

  const handleTouchEnd = (e) => {
    touchEndX = e.changedTouches[0].clientX;
    touchEndY = e.changedTouches[0].clientY;

    const deltaX = touchEndX - touchStartX;
    const deltaY = touchEndY - touchStartY;

    if (Math.abs(deltaX) > Math.abs(deltaY)) {
      // Horizontal swipe
      if (deltaX > swipeThreshold) {
        toPreviousItem();
        //alert('Swiped right');
      } else if (deltaX < -swipeThreshold) {
        toNextItem();
        //alert('Swiped left');
      }
    } else {
      // Vertical swipe
      if (deltaY > swipeThreshold) {
        toNextItem();
        //alert('Swiped down');
      } else if (deltaY < -swipeThreshold) {
        toPreviousItem();
        //alert('Swiped up');
      }
    }
  };

  return (
    <>
      <div
        className='modal'
        onTouchStart={handleTouchStart}
        // onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
        <button className='modal-close-button' onClick={closeModal}>
          <img
            className='modal-close'
            src='../../../img/button_close_w.svg'
            alt='modal close button'
          />
        </button>

        <button
          type='button'
          className='modal-button left'
          onClick={toPreviousItem}
        >
          <img
            className='arrow '
            src='../../../img/arrow-back.svg'
            alt='arrow back button'
          />
        </button>
        <button
          type='button'
          className='modal-button right'
          onClick={toNextItem}
        >
          <img
            className='arrow '
            src='../../../img/arrow-fwd.svg'
            alt='arrow forward button'
          />
        </button>

        <div
          className={
            currentItem.dataset.type !== 'video'
              ? 'modal-inner'
              : 'modal-inner video'
          }
        >
          <div className='main-media'>
            {currentItem.dataset.type !== 'video' ? (
              <img
                src={currentModalDetails.imageurl}
                className='mainImage'
                alt='modal img'
              />
            ) : (
              <iframe
                src={`https://www.youtube.com/embed/${currentModalDetails.videourl}?rel=0&amp;controls=1&amp;showinfo=0`}
                width='192'
                height='108'
                allowFullScreen='allowfullscreen'
                className='mainImage'
                title='modal video'
              ></iframe>
            )}
          </div>
          <div className='mainText-container'>
            <div className='main-text'>
              <h2>{currentModalDetails.heading}</h2>
              <div>{parse(currentModalDetails.text)}</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default SwipeComponent;
